import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, Dispatch } from '@/core/redux/store';

export const useCustomDispatch: () => Dispatch = useDispatch;
export const useCustomSelector: TypedUseSelectorHook<RootState> = useSelector;
